import React from 'react';
import { ChevronUp, Facebook, Twitter, Youtube, Mail, Phone, MapPin, Heart } from 'react-feather';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-neutral-900 to-neutral-800 text-white">
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Back to Top Button */}
        <motion.div
          className="absolute right-4 top-4 sm:right-6 sm:top-6 lg:right-8 lg:top-8"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <a
            className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-r from-primary-600 to-primary-700 text-white shadow-large transition-all duration-300 hover:shadow-xl hover:from-primary-700 hover:to-primary-800"
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            <span className="sr-only">Back to top</span>
            <ChevronUp className="w-5 h-5" />
          </a>
        </motion.div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
                <img
              src={process.env.PUBLIC_URL + '/logo512.png'}
              alt="logo"
              className="object-contain h-auto w-32 lg:w-40"
            />
              <div>
                <h3 className="text-xl font-bold text-white">Dawa Mtaani</h3>
                <p className="text-neutral-400 text-sm">Your Health Partner</p>
              </div>
            </div>
            <p className="text-neutral-300 mb-6 leading-relaxed">
              Providing quality healthcare products and expert pharmaceutical services to keep you and your family healthy.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-neutral-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <Facebook className="w-5 h-5" />
              </motion.a>
              <motion.a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-neutral-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <Twitter className="w-5 h-5" />
              </motion.a>
              <motion.a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-neutral-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <Youtube className="w-5 h-5" />
              </motion.a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Shop', 'Services', 'About Us', 'Contact', 'Blog'].map((link) => (
                <li key={link}>
                  <a
                    href={`/${link.toLowerCase().replace(' ', '-')}`}
                    className="text-neutral-300 hover:text-primary-400 transition-colors duration-300 flex items-center space-x-2 group"
                  >
                    <span className="w-1 h-1 bg-primary-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span>{link}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Our Services</h4>
            <ul className="space-y-3">
              {['Prescription Medicines', 'Health Consultations', 'Blood Pressure Check', 'Blood Sugar Check', 'Nutritional Supplements'].map((service) => (
                <li key={service}>
                  <a
                    href="#"
                    className="text-neutral-300 hover:text-primary-400 transition-colors duration-300 flex items-center space-x-2 group"
                  >
                    <span className="w-1 h-1 bg-primary-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    <span>{service}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-neutral-300">P.O BOX test - 00606</p>
                  <p className="text-neutral-300">Nairobi, Kenya</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <p className="text-neutral-300">+254 101 757 541</p>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary-400 flex-shrink-0" />
                <p className="text-neutral-300">maxmapharmacy@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-neutral-400">
              <span>© 2024 Maxma Pharmacy. Made with</span>
              <Heart className="w-4 h-4 text-red-500 fill-current" />
              <span>for your health</span>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy" className="text-neutral-400 hover:text-primary-400 transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="/terms" className="text-neutral-400 hover:text-primary-400 transition-colors duration-300">
                Terms of Service
              </a>
              <a href="/cookies" className="text-neutral-400 hover:text-primary-400 transition-colors duration-300">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
